<template>
  <div class="map" style="position: relative">
    <div id="allmap" class="allmap"></div>
  </div>
</template>

<script>
import CommonApi from "@/api/common";
import MapStyle from "./custom_map_config";
export default {
  data() {
    return {
      map: null,
      regionData: {},
      fs: [],
      showOverlay: true,
      overlayList: [],
      selectAreaCode: "",
    };
  },
  mounted() {
    this.addMap();
    this.addControl();
    this.map.addEventListener("zoomend", (evt) => {
      if (this.map.getZoom() > 13 && this.showOverlay === true) {
        this.showOverlay = false;
        this.hideOverlays();
      } else if (this.map.getZoom() <= 13 && this.showOverlay === false) {
        this.showOverlay = true;
        this.showOverlays();
      }
    });

    CommonApi.streetGeomInfo({}).then((res) => {
      this.regionData = res.data.data;
      this.addPolygon();
    });
  },
  methods: {
    addMap() {
      this.map = new BMapGL.Map("allmap");
      // this.map.centerAndZoom(new BMapGL.Point(120.64019, 30.989191), 11);
      this.map.centerAndZoom(new BMapGL.Point(120.66019, 31.430191), 10);
      // this.map.setMapType(BMAP_SATELLITE_MAP);

      this.map.enableScrollWheelZoom(true);

      this.$nextTick(() => {
        this.map.setMapStyleV2({
          styleJson: MapStyle,
        });
      });
    },
    addControl() {
      var opts1 = {
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMapGL.Size(30, 30),
      };
      var opts2 = {
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMapGL.Size(80, 30),
      };
      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var scaleCtrl = new BMapGL.ScaleControl(opts2); // 添加比例尺控件
      this.map.addControl(scaleCtrl);
      var zoomCtrl = new BMapGL.ZoomControl(opts1); // 添加缩放控件
      this.map.addControl(zoomCtrl);
    },

    addPolygon(flag = false) {
      let json = this.regionData;
      this.overlayList = [];
      let region = {
        type: "FeatureCollection",
        features: [],
      };
      json.forEach((item) => {
        let dic = {
          type: "Feature",
          properties: {
            type: "area",
            adcode: item.townCode,
            name: item.townName,
            center: JSON.parse(item.centroidGeoJson).coordinates,
            centroid: JSON.parse(item.centroidGeoJson).coordinates,
          },
          geometry: JSON.parse(item.streetGeoJson),
        };
        region.features.push(dic);
      });

      var that = this;
      var colorBand = ["#409EFF", "cadetblue", "orange", "red", "tan"];
      var gParse = new BMapGL.GeoJSONParse({
        reference: "WGS84",
      });
      this.fs = gParse.readFeaturesFromObject(
        region,
        {
          fillColor: "transparent",
          fillOpacity: flag === false ? 0.2 : 0,
        },
        function (overlay) {
          var index = overlay.properties.join || 0;
          overlay.setFillColor(colorBand[index]);
          overlay.setStrokeColor(colorBand[index]);
          overlay.setZIndex(-2);
          overlay.addEventListener("mouseover", function (e) {
            e.currentTarget.setFillColor("red");
          });
          overlay.addEventListener("mouseout", function (e) {
            e.currentTarget.setFillColor(colorBand[index]);
          });
          overlay.addEventListener("click", function (e) {
            that.$router.push(
              "/mapGisBig?towncode=" +
                overlay.properties.adcode +
                "&coordinates=" +
                overlay.properties.center.join(",")
            );
          });
          overlay.name = "area";
          that.map.addOverlay(overlay);

          var point = new BMapGL.Point(
            overlay.properties.center[0],
            overlay.properties.center[1]
          ); // 创建文字标注的位置点
          var label = new BMapGL.Label(overlay.properties.name, {
            offset: new BMapGL.Size(-10, -10),
          }); // 创建文字标注对象
          label.name = "areaName";
          label.setStyle({
            // 设置文字标注样式
            "background-color": colorBand[index],
            border: "1px solid white",
            color: "white", // 文字颜色
            "border-radius": "4px",
            padding: "0px 6px",
            fontSize: "14px", // 文字大小
            height: "20px", // 文字高度
            lineHeight: "20px", // 文字行高
            fontFamily: "微软雅黑", // 文字字体
          });
          label.setPosition(point); // 设置文字标注的位置
          that.map.addOverlay(label); // 将文字标注添加到地图中
          that.overlayList.push(overlay);
        }
      );
    },
    hideOtherOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (
          item.name != "car" &&
          item.name != "areaName" &&
          item.name != "area"
        ) {
          this.map.removeOverlay(item);
        }
      });
    },
    hideOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (item.name === "area" || item.name === "areaName") {
          this.map.removeOverlay(item);
        }
      });
      this.addPolygon(true);
    },
    showOverlays() {
      var markers = this.map.getOverlays();
      markers.forEach((item) => {
        if (item.toString() === "Polygon" || item.toString() === "Label") {
          this.map.removeOverlay(item);
        }
      });
      this.addPolygon();
    },
  },
};
</script>

<style lang="scss" scoped>
body,
html,
.allmap,
.map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
}
.map {
  position: relative;
}
</style>
